import React from 'react';
import SideMenu from '../components/SideMenu';
import UserMenu from '../components/UserMenu';
import MainContent from '../components/MainContent';
import Header from '../components/Header';

const ModifyPDEdetailsAfterSubmit = () => {
  return (
    <div className="flex h-screen">
    <SideMenu />
    <div className="flex-1 flex flex-col">
        <Header />
        <div className="flex flex-1">
            {/* Left Side */}
            <div className="flex-1 p-4">
            <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
            <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-4xl">
                <div className="flex justify-between items-center mb-4">
                    <div className="flex flex-col space-y-4 w-full">
                        <div className="flex items-center space-x-4">
                            <label className="w-1/4 text-gray-700">PDE ID</label>
                            <input type="text" className="w-2/3 px-4 py-2 border rounded" />
                            <button className="w-1/3 bg-blue-500 text-white px-4 py-2 rounded">Verify PDE</button>
                        </div>
                        <div className="flex items-center space-x-4">
                            <label className="w-1/4 text-gray-700">Select Table</label>
                            <select className="w-2/3 px-4 py-2 border rounded">
                                <option>Select a table</option>
                                {/* Add more options as needed */}
                            </select>
                            <button className="w-1/3 bg-blue-500 text-white px-4 py-2 rounded">Modify</button>
                        </div>
                    </div>
                    <button className="w-1/6 bg-blue-500 text-white px-4 py-2 rounded">Print</button>
                </div>
                <div className="flex justify-between space-x-4">
                    <div className="w-1/2 bg-gray-200 h-56 p-4 rounded-lg"></div>
                    <div className="w-1/2 bg-gray-200 h-56 p-4 rounded-lg"></div>
                </div>
                <div className="flex justify-center mt-6">
                    <button className="bg-blue-500 text-white px-6 py-2 rounded">Update</button>
                </div>
            </div>
        </div>
</div>


            {/* Right Side */}
         
        </div>
    </div>
</div>
  )
}

export default ModifyPDEdetailsAfterSubmit
